import { NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { ManagementViewComponent } from './management-view/management-view.component';
import { TranslocoModule } from '@jsverse/transloco';
import { MarkantElementsModule } from '@markant/elements-angular';
import { CartridgeDataAccessModule } from '@markant-platform/cartridge/data-access';
import localeDe from '@angular/common/locales/de';
import { FormsModule } from '@angular/forms';
import { CartridgeFeatureManagementViewRoutingModule } from './cartridge-feature-management-view-routing.module';
import { CartridgeFeatureGridModule } from '@markant-platform/cartridge-feature-grid';
import { CancelProcessComponent } from './management-view/cancel-process/cancel-process.component';
import { SharedUiInfoCalloutModule } from '@markant-platform/shared/ui-info-callout';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';
import { TranslocoCurrencyPipe, TranslocoDatePipe } from '@jsverse/transloco-locale';
import { ContractDataManagementTileComponent } from './management-view/tiles/contract-data/contract-data.component';
import { ServiceDocumentsManagementTileComponent } from './management-view/tiles/service-documents/service-documents.component';
import { CancellationManagementTileComponent } from './management-view/tiles/cancellation/cancellation.component';
import { EligibleUserManagementTileComponent } from './management-view/tiles/eligible-user/eligible-user.component';
import { PaymentDataManagementTileComponent } from './management-view/tiles/payment-data/payment-data.component';
import { CalculationParametersTileComponent } from './management-view/tiles/calculation-parameters/calculation-parameters.component';
import { BulkPriceManagementTileComponent } from './management-view/tiles/bulk-price/bulk-price.component';
import { CartridgeUiPriceModule } from '@markant-platform/cartridge/ui-price';
import { SharedOrganizationFeatureModule } from '@markant-platform/shared/organization/feature';
import { ServiceResponsibilityTileComponent } from './management-view/tiles/service-responsibility/service-responsibility.component';
import { ServiceResponsibilityDialogComponent } from './management-view/service-responsibility-dialog/service-responsibility-dialog.component';
import { SharedDialogFeatureModule } from '@markant-platform/shared/dialog/feature';
import { UiCardComponent, UiCardItemComponent } from '@markant-platform/shared/ui-card';
import { UsageReportComponent } from './management-view/tiles/usage-report/usage-report.component';
import { UsageReportTileComponent } from '@markant-platform/shared/usage/feature';
import { ArrayIncludesPipe, IsBulkPricePipe } from '@markant-platform/shared/util-pipes';
import { UiPageHeaderComponent } from '@markant-platform/shared/ui-components';
import { UpgradeVariantModalComponent } from './management-view/upgrade-variant-modal/upgrade-variant-modal.component';

registerLocaleData(localeDe);

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    MarkantElementsModule,
    CartridgeDataAccessModule,
    FormsModule,
    CartridgeFeatureManagementViewRoutingModule,
    CartridgeFeatureGridModule,
    SharedUiInfoCalloutModule,
    ModalBridgeComponent,
    TranslocoDatePipe,
    TranslocoCurrencyPipe,
    CartridgeUiPriceModule,
    SharedOrganizationFeatureModule,
    SharedDialogFeatureModule,
    UiCardComponent,
    UiCardItemComponent,
    UsageReportTileComponent,
    ArrayIncludesPipe,
    IsBulkPricePipe,
    UiPageHeaderComponent,
    UpgradeVariantModalComponent,
  ],
  exports: [ManagementViewComponent],
  declarations: [
    ManagementViewComponent,
    CancelProcessComponent,
    ContractDataManagementTileComponent,
    ServiceDocumentsManagementTileComponent,
    CancellationManagementTileComponent,
    EligibleUserManagementTileComponent,
    PaymentDataManagementTileComponent,
    CalculationParametersTileComponent,
    BulkPriceManagementTileComponent,
    ServiceResponsibilityTileComponent,
    ServiceResponsibilityDialogComponent,
    UsageReportComponent,
  ],
})
export class CartridgeFeatureManagementViewModule {}
